import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faUser,
  faGripVertical,
} from "@fortawesome/free-solid-svg-icons";
import { useDrag, useDrop } from "react-dnd";

const RecipientCard = ({
  recipient,
  index,
  remove,
  register,
  errors,
  moveRecipient,
  isEdit,
}) => {
  const borderColors = [
    "bg-yellow-400",
    "bg-green-400",
    "bg-blue-400",
    "bg-indigo-400",
    "bg-purple-400",
    "bg-pink-400",
  ];

  const colorIndex = index % borderColors.length;
  const borderColorClass = borderColors[colorIndex];

  const ref = useRef(null);

  const [, drag] = useDrag({
    type: "RECIPIENT",
    item: { id: recipient.id, index },
  });

  const [, drop] = useDrop({
    accept: "RECIPIENT",
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();

      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();

      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveRecipient(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  drag(drop(ref));

  return (
    <div ref={ref} className="flex">
      {" "}
      <div className="relative w-4">
        <div className="absolute left-1 top-2 cursor-grab">
          <FontAwesomeIcon icon={faGripVertical} className="text-gray-400" />
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-200 relative flex-1">
        <div
          className={`absolute left-0 top-0 bottom-0 w-1 rounded-l-lg ${borderColorClass}`}
        ></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
          <div>
            <label
              htmlFor={`recipients[${index}].role`}
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Role:
            </label>
            <input
              type="text"
              {...register(`recipients[${index}].signer_role_name`, {
                required: "Name is required",
                validate: (value) => {
                  if (value?.trim() === "") {
                    return "role cannot be empty or just spaces";
                  }
                  return true;
                },
              })}
              className="shadow appearance-none border ring-1 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-[#cfc9ff] "
            />
            {errors.recipients?.[index]?.role && (
              <p className="text-red-500 text-xs italic">
                {errors.recipients[index].role.message}
              </p>
            )}
          </div>

          <div>
            <label
              htmlFor={`recipients[${index}].name`}
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Name:
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FontAwesomeIcon icon={faUser} className="text-gray-500" />
              </div>
              <input
                type="text"
                {...register(`recipients[${index}].name`, {
                  // required: "Name is required",
                  // validate: (value) => {
                  //   if (value.trim() === "") {
                  //     return "Name cannot be empty or just spaces";
                  //   }
                  //   return true;
                  // },
                })}
                className="shadow appearance-none border ring-1 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-[#cfc9ff]  pl-10"
              />
            </div>
            {errors.recipients?.[index]?.name && (
              <p className="text-red-500 text-xs italic">
                {errors.recipients[index].name.message}
              </p>
            )}
          </div>
          <div>
            <label
              htmlFor={`recipients[${index}].email`}
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Email:
            </label>
            <input
              type="email"
              autoComplete="email"
              disabled={isEdit}
              {...register(`recipients[${index}].email`, {
                // required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              })}
              className="shadow disabled:cursor-not-allowed appearance-none border ring-1 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-[#cfc9ff] "
            />
            {errors.recipients?.[index]?.email && (
              <p className="text-red-500 text-xs italic">
                {errors.recipients[index].email.message}
              </p>
            )}
          </div>
        </div>

        <div className="md:flex items-center space-y-2 md:space-y-0 md:space-x-4">
          <div>
            <label
              htmlFor={`recipients[${index}].action`}
              className="block text-gray-700 text-sm font-bold mb-2 md:hidden"
            >
              Action:
            </label>
            {/* <div className="relative inline-block w-full md:w-auto">
              <select
                {...register(`recipients[${index}].action`)}
                className="shadow appearance-none border rounded right-1 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-[#cfc9ff]  pr-8"
              >
                <option value="Needs to Sign">Needs to Sign</option>
                <option value="In Person Signer">In Person Signer</option>
                <option value="Receives a Copy">Receives a Copy</option>
                <option value="Needs to View">Needs to View</option>
              </select>
            </div> */}
          </div>
        </div>

        <button
          type="button"
          onClick={() => remove(index)}
          className="absolute top-2 right-2  hover:bg-gray-200 text-red-400 font-bold py-1 px-2 rounded text-sm"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
};

export default RecipientCard;
